import * as lodash from 'lodash'

// Airbnb API failures reach the client as one '; '-joined string, e.g.
// "AirBnB error: Invalid cancellation policy; error_type=validation; error_class=ValidationError;
// error_id=api_frwrk_...; error_details=[{"error_message":"Invalid cancellation policy"}]".
// The structured segments exist for diagnostics/logs and must never be rendered to users.
const AIRBNB_DIAGNOSTIC_SEGMENT = /;\s*(?=(?:error_type|error_class|error_reason|error_id|error_details)=)/

export function airbnbErrorDisplayMessage(raw: string): string {
  if (!raw || !lodash.isString(raw)) {
    return raw
  }
  const segments = raw.split(AIRBNB_DIAGNOSTIC_SEGMENT)
  const lead = segments[0].trim()
  const details = lodash
    .uniq(
      segments
        .slice(1)
        .filter((segment) => lodash.startsWith(segment, 'error_details='))
        .reduce((acc, segment) => acc.concat(parseErrorDetails(segment.slice('error_details='.length))), [] as string[])
    )
    .filter((message) => !lead.toLowerCase().includes(message.toLowerCase()))
  if (!details.length) {
    return lead
  }
  return [lead, ...details].map((message) => message.replace(/\.+$/, '')).join('. ') + '.'
}

function parseErrorDetails(json: string): string[] {
  let parsed: any
  try {
    parsed = JSON.parse(json)
  } catch (e) {
    return []
  }
  const items = Array.isArray(parsed) ? parsed : [parsed]
  return items
    .map((item) => (lodash.isString(item) ? item : item?.error_message || item?.message))
    .filter((message) => lodash.isString(message) && message.trim().length)
    .map((message) => message.trim())
}
